import 'primereact/resources/themes/md-light-deeppurple/theme.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query';
import { BrowserRouter } from "react-router";
import App from './components/App';
import { PrimeReactProvider, PrimeReactContext, APIOptions } from 'primereact/api';

const root = createRoot(document.getElementById('kx-search-root') as HTMLElement);
const queryClient = new QueryClient();

const options: Partial<APIOptions> = {
    appendTo: 'self',
    ripple: true,
};

root.render(
    <PrimeReactProvider value={options}>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </QueryClientProvider>
    </PrimeReactProvider>
);